var map = {
	"./aebersold.jpg": 318,
	"./eicher.jpg": 319,
	"./fuchs.jpg": 320,
	"./hoefler.jpg": 321,
	"./jans.jpg": 322,
	"./kruit.jpg": 323,
	"./liebi.jpg": 324,
	"./nause.jpg": 325,
	"./richner.jpg": 326,
	"./righetti.jpg": 327,
	"./schild.jpg": 328,
	"./soelch.jpg": 329,
	"./teuscher.jpg": 330,
	"./theiler.jpg": 331,
	"./velkova.jpg": 332,
	"./vongraffenried.jpg": 333
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80;